import { render } from "./CicoButton.vue?vue&type=template&id=1f06e464&scoped=true"
import script from "./CicoButton.vue?vue&type=script&lang=js"
export * from "./CicoButton.vue?vue&type=script&lang=js"

import "./CicoButton.vue?vue&type=style&index=0&id=1f06e464&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f06e464"]])

export default __exports__